import React from "react";
import ExTable, {ExTableProps} from "./ExTable";
import {ListRequest, BaseModelType} from "../../app/api/types";

export interface IdModel extends BaseModelType {
    ["id"]: number;
}

export type IdModelTableProps<T extends IdModel, U extends ListRequest> = Omit<ExTableProps<T, U>, "keyFieldName">;

export function IdModelTable<T extends IdModel, U extends ListRequest>(props: IdModelTableProps<T, U>) {
    return <ExTable keyFieldName={"id"} {...props} />;
}

export type ListRequestIdModelTableProps<T extends IdModel> = Omit<
    IdModelTableProps<T, ListRequest>,
    "additionalRequestParams"
>;

export function ListRequestIdModelTable<T extends IdModel>(props: ListRequestIdModelTableProps<T>) {
    return <ExTable keyFieldName={"id"} additionalRequestParams={{}} {...props} />;
}
